module.exports = __webpack_public_path__ + "static/media/sprint-logo.b63c4d98.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/components/Header/resources/sprint-logo.svg
// module id = 3383
// module chunks = 0